import { PrescriptionDocument } from "./draMei/PDFPrescription";
import { RequestDocument } from "./draMei/PDFRequest";

import { PDFFileType } from "./FileTypeGenerate";

export const PDF = {
  prescription: PDFFileType(PrescriptionDocument),
  request: PDFFileType(RequestDocument),
}
